import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, Grid } from "@mui/material";
import Header from "../header";
import { Button } from "@mui/material";
import { useMutation } from "react-query";
import { FinalizerOrderItems, GetCartInfo } from "../../service/store.service";
import { ApiResultModel } from "../../../models/common.model";
import {
    CartItemRequest,
    DeleteCartItemResponse,
    FinalizerOrderItemsRequest,
    GetCartInfoResponse,
    StoreResponse,
} from "../../models/store.model";
import FinalModal from "../modals/finalModal";
import EmptyList from "../historyList/emptyList";
import CartCard from "./cartCard";
import CartSkeleton from "./cartSkeleton";
import { useHistory } from "react-router-dom";

export default function Cart() {
    const [checked, setChecked] = React.useState(() =>
        cartData?.items.map((i) => true)
    );
    const [selected, setSelected] = React.useState<any>(0);
    const [updateCart, setUpdateCart] = React.useState(false);
    const [finalOrder, setFinalOrder] = React.useState<any[]>([]);
    const [cartData, setCartData] = React.useState<GetCartInfoResponse>();
    const [openCancelModal, setOpenCancelModal] = React.useState<boolean>(false);
    const [validationIssues, setValidationIssues] = React.useState<any[]>([]);
    const [items, setItems] = React.useState<any[]>([]);
    const [totalAmount, setTotalAmount] = React.useState(0);
    // React.useEffect(() => {
    //     getCartInfo.mutate();
    // }, [])

    React.useEffect(() => {
        setSelected(checked?.filter((i) => i === true));
    }, [checked]);

    React.useEffect(() => {
        if (cartData?.items?.length === 0 && updateCart !== false) {
            history.replace({
                pathname: '/products/historyList'
            })
        }
    }, [cartData]);

    React.useEffect(() => {
        getCartInfo.mutate();
    }, [updateCart || validationIssues]);

    const history = useHistory();
    const getCartInfo = useMutation(GetCartInfo, {
        onSuccess: (result: ApiResultModel<GetCartInfoResponse>) => {
            if (result.data) {
                setChecked(() => result.data?.items.map((i) => true));
                setCartData(result.data);
                handleChange(result.data);
                setTotalAmount(result.data?.totalAmount!);
            }
        },
    });
    // const finalizerOrderItems = useMutation(FinalizerOrderItems, {
    //     onSuccess: (result: ApiResultModel<DeleteCartItemResponse>) => {
    //         if (result.isSuccess === true) {
    //             // setCartData(result.data);
    //         } else {
    //         }
    //     },
    // });

    const handelVerify = () => {
        const request = [] as any;
        finalOrder.map((item: any, key: number) => {
            const cartItemRequest = {} as CartItemRequest;
            cartItemRequest.inventoryId = item[1];
            cartItemRequest.orderId = item[0];
            request[key] = cartItemRequest;

            //   finalizerOrderItemsRequest.items = request;
            // finalizerOrderItems.mutate(finalizerOrderItemsRequest)
        });
        setItems(request);
        setOpenCancelModal(true);
    };

    const handleChangeSelectedAll = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        let addCartItem = [] as any;
        let addData = [] as any;
        if (event.target.checked === true && cartData!.items.length > 0) {
            cartData?.items?.map((item: any) => {
                addCartItem = [item.orderId, item.inventoryId];
                addData.push(addCartItem);
            });
            setFinalOrder(addData);
            setTotalAmount(cartData?.totalAmount!);
        } else {
            setFinalOrder([]);
            setTotalAmount(0);
        }
        let arr = [] as any;
        checked?.map(() =>
            arr.push(event.target.checked)
        )
        setChecked(arr);
    };

    function handleChange(val: any) {
        let addCartItem = [] as any;
        let addData = [] as any;
        if (val!.items.length > 0) {
            val?.items?.map((item: any) => {
                addCartItem = [item.orderId, item.inventoryId];
                addData.push(addCartItem);
            });
            setFinalOrder(addData);
        } else {
            setFinalOrder([]);
        }
    }

    const isCheckboxChecked = (
        index: any,
        check2: any,
        orderId: any,
        inventoryId: any,
        finalAmount: any
    ) => {
        let array = [orderId, inventoryId];
        if (checked?.length! <= 1 && check2 === true) {
            let order = [...finalOrder, array];
            setFinalOrder(order);
            setTotalAmount(totalAmount + finalAmount);
        } else if (checked?.length! <= 1 && check2 === false) {
            const selectedItem = finalOrder.filter((item: any, key: number) => {
                return item[0] !== array[0] || item[1] !== array[1];
            });
            setFinalOrder(selectedItem);
            setTotalAmount(totalAmount - finalAmount);
        }
        setChecked((check: any) => {
            return checked?.map((c: any, i: any) => {
                if (i === index) return check2;
                if (check2 === true) {
                    let order = [...finalOrder, array];
                    setFinalOrder(order);
                    setTotalAmount(totalAmount + finalAmount);
                } else {
                    const selectedItem = finalOrder.filter((item: any, key: number) => {
                        return item[0] !== array[0] || item[1] !== array[1];
                    });
                    setFinalOrder(selectedItem);
                    setTotalAmount(totalAmount - finalAmount);
                }
                return c;
            });
        });
    };

    const children = (
        <Box
            sx={{ display: "flex", flexDirection: "column", ml: 3 }}
            style={{ width: "100%", paddingRight: "10.5vh", paddingLeft: "12vh" }}
        >
            {cartData?.items.length === 0 ? (
                <EmptyList image={"images/Bascket.png"} image2={true} />
            ) : (
                cartData?.items.map((item: any, key: number) => (
                    <FormControlLabel
                        key={key + item.title}
                        style={{ paddingRight: "10px", width: "100%" }}
                        className="cartBox"
                        label={
                            <CartCard
                                cartItem={item}
                                setUpdateCart={setUpdateCart}
                                validationIssues={validationIssues}
                            />
                        }
                        control={
                            <Checkbox
                                disabled={validationIssues.length !== 0}
                                className={`${validationIssues.length !== 0
                                    ? " disableCheckbox"
                                    : "checkboxCart"
                                    }`}
                                // className="checkboxCart"
                                checked={checked![key]}
                                onChange={(e: any) =>
                                    isCheckboxChecked(
                                        key,
                                        e.target.checked,
                                        item.orderId,
                                        item.inventoryId,
                                        item.finalAmount
                                    )
                                }
                                style={
                                    validationIssues.length === 0
                                        ? { marginTop: "3vh" }
                                        : { marginTop: "11vh" }
                                }
                            />
                        }
                    />
                ))
            )}
        </Box>
    );

    return (
        <div>
            <Grid container xs={12}>
                <Grid item xs={12}>
                    <Header search={true} category={true} parentCategoryId={1} />
                </Grid>
                <Grid item xs={12}>
                    {cartData ? (
                        cartData?.items.length === 0 ? (
                            ""
                        ) : (
                            <Grid
                                container
                                xs={12}
                                style={{ paddingRight: "12vh", paddingLeft: "12vh" }}
                            >
                                <Grid item xs={10}>
                                    <FormControlLabel
                                        label={
                                            <>
                                                <Grid container xs={12}>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                            font: "16px",
                                                            color: "#1D4A87",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        انتخاب همه
                                                    </Grid>
                                                    <Grid>
                                                        <span style={{ font: "14px", color: "#424242" }}>
                                                            (&nbsp;
                                                        </span>
                                                        <span style={{ font: "12px", color: "#424242" }}>
                                                            جمع قابل پرداخت
                                                        </span>
                                                        <span
                                                            style={{
                                                                font: "14px",
                                                                color: "#424242",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            &nbsp;{totalAmount.toLocaleString()}&nbsp;
                                                        </span>
                                                        <span style={{ font: "12px", color: "#424242" }}>
                                                            ریال
                                                        </span>
                                                        <span style={{ font: "14px", color: "#424242" }}>
                                                            {" "}
                                                            ){" "}
                                                        </span>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                        control={
                                            <Checkbox
                                                style={{ marginTop: "-10px" }}
                                                checked={
                                                    selected?.length === checked?.length! &&
                                                    selected?.length > 0
                                                }
                                                // indeterminate={true}
                                                onChange={handleChangeSelectedAll}
                                                className="checkboxCart"
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid item xs={2} style={{ textAlign: 'center' }}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        className={
                                            finalOrder.length > 0
                                                ? "btnFormCart SuccessDefault Vazirmatn sumbitButtonCart "
                                                : "btnFormCart disabledBtn Vazirmatn sumbitButtonCart"
                                        }
                                        disabled={finalOrder.length === 0}
                                        onClick={handelVerify}
                                    >
                                        ثبت و تایید نهایی
                                    </Button>
                                </Grid>
                            </Grid>
                        )
                    ) : (
                        <CartSkeleton />
                    )}
                </Grid>
                {children}
            </Grid>
            <FinalModal
                setOpenCancelModal={setOpenCancelModal}
                openCancelModal={openCancelModal}
                requestModel={items}
                setUpdateCart={setUpdateCart}
                setValidationIssues={setValidationIssues}
            />
        </div>
    );
}
